import React, { useState, useEffect, useMemo } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { Tabs, DefaultTabBar } from 'rmc-tabs';
import { CommunityService } from '../../../common/services';
import Pagination from '../../../components/pagination';
import CommunityModel from '../../community/store/model';
import Seo from '../../../components/seo';
import { CategoryTabsWrap } from './styled';

const CATEGORIES = [
  { title: '전체', key: 'all' },
  { title: '공지사항', key: 'notice' },
  { title: '업데이트', key: 'update' },
  { title: '이벤트', key: 'event' },
  { title: '보증정보', key: 'trusted' }
];

const CustomerCenterNotice = () => {
  const location = useLocation();
  const history = useHistory();
  
  const { page, categoryParam } = useMemo(() => {
    const query = new URLSearchParams(location.search);
    return {
      page: parseInt(query.get('page')) || 1,
      categoryParam: query.get('category') || 'all'
    };
  }, [location.search]);

  const handleTabChange = (tab) => {
    if (tab.key !== categoryParam) {
      history.push(`/customercenter/notice?page=1&category=${tab.key}`);
    }
  };

  return (
    <div className="board_wrap">
      <Seo title="고객센터 공지사항" />
      <CategoryTabsWrap>
        <Tabs
          tabs={CATEGORIES}
          page={categoryParam}
          onChange={handleTabChange}
          noRenderContent={true}
          renderTabBar={props => (
            <DefaultTabBar
              {...props}
              page={5}
              tabBarUnderlineStyle={{ backgroundColor: '#FF5A5F', height: '2px', border: 'none' }}
              renderTab={(tab) => {
                if (tab.key === 'trusted') {
                  return (
                    <span className="cc_notice_tab_with_badge">
                      <span className="cc_notice_tab_title">{tab.title}</span>
                      <span className="big_new_icon" />
                    </span>
                  );
                }
                return <span className="cc_notice_tab_title">{tab.title}</span>;
              }}
            />
          )}
        />
        <div className="custom-tab-content" style={{ marginTop: '10px' }}>
          <NoticeList 
            page={page} 
            category={categoryParam} 
          />
        </div>
      </CategoryTabsWrap>
    </div>
  );
};

const NoticeList = ({ page, category }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ boardNotice: [], list: [], totalCount: 0 });

  useEffect(() => {
    let isMounted = true; 

    const fetchNotices = async () => {
      setLoading(true);
      try {
        const res = await CommunityService.getCustomerCenterNotice(page, category);
        if (!isMounted) return;

        if (res.code === 200) {
          setData({
            totalCount: res.data.total_cnt,
            boardNotice: page === 1
              ? (res.data.board_notice || []).map(item => new CommunityModel(item)) 
              : [],
            list: (res.data.list || []).map(item => new CommunityModel(item))
          });
        }
      } catch (error) {
         console.error(error);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchNotices();
    return () => { isMounted = false; };
  }, [page, category]);

  return (
    <div className="board_list">
      {loading && <div className="spinner" style={{ textAlign: 'center', padding: '20px' }} />}
      <div className="list_area" style={{ opacity: loading ? 0.5 : 1 }}>
        {data.boardNotice.map(item => (
          <Row item={item} key={`${item.wr_id}-notice`} isBoardNotice={true} />
        ))}
        {data.list.map(item => (
          <Row 
            item={item} 
            key={item.wr_id} 
          />
        ))}
      </div>
      {data.totalCount > 0 && (
        <Pagination page={page} totalCount={data.totalCount} category={category} rowCount={20} />
      )}
    </div>
  );
};

const Row = ({ item, isBoardNotice }) => {
  const { time, wr_id, wr_subject, ca_name, wr_name, wr_hit, board_type } = item;
  const detailType = board_type || 'notice';
  return (
    <div className="article">
      <Link className={clsx('item', isBoardNotice && 'notice_top')} to={`/customercenter/${detailType}/${wr_id}`}>
        <p className="subject">{wr_subject}</p>
        <p className="info">
          <span className={clsx('category', isBoardNotice && 'notice_top')}>{ca_name}</span>
          <span className="name">{wr_name}</span>
          <span className="date">{time}</span>
          <span className="count">조회 {new Intl.NumberFormat("ko-KR").format(wr_hit)}</span>
        </p>
      </Link>
    </div>
  );
};

export default CustomerCenterNotice;
